import { render } from "./DataRetention.vue?vue&type=template&id=bcd23ef0&scoped=true"
import script from "./DataRetention.vue?vue&type=script&lang=js"
export * from "./DataRetention.vue?vue&type=script&lang=js"

import "./DataRetention.vue?vue&type=style&index=0&id=bcd23ef0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd23ef0"]])

export default __exports__